<template>
  <div class="animated fadeIn">
    <b-card header="톡채널 등록/조회 > 목록">
      <b-button type="button" class="btn btn-sm" :to="{name: 'plusFriendNew'}" style="position: absolute; right: 1.25rem; font-weight: bold" variant="primary">등록</b-button>
      <b-form-input id="plusfriend" v-model="search" placeholder="톡채널 이름을 입력해주세요." class="d-inline-block ml-2" style="width: 250px;"></b-form-input>
      <b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="filteredList" :fields="fields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다." :sort-by="sortBy" :sort-desc="true">
        <template slot="appName" slot-scope="data">
          {{getAppName(data.item)}}
        </template>
        <template slot="title" slot-scope="data">
          <b-link :to="{name: 'plusFriendEdit', query: { appMasterId: data.item.appMasterId}}">{{data.item.title}}</b-link>
        </template>
        <template slot="modTime" slot-scope="data">
          {{ data.item.modTime ? getFormattedDate(data.item.modTime) : '비 설정' }}
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="this.filteredList.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-card>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import { MODULE_NAME as APP_MODULE, FETCH_APPS } from '@/store/app/actions.type'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import playGameService from '@/common/api/playGame.service'
  import GameCenterService from '@/common/api/gameCenter.service'
  import { $showModalWithErrorMsg } from '@/common/util'
  import moment from 'moment'
  export default {
    data () {
      return {
        search: '',
        currentPage: 1,
        perPage: 30,
        sortBy: 'modStatusTime',
        fields: [
          {key: 'viewInfo.plusFriendId', label: '톡채널 ID', class: 'text-center', thStyle: {width: '300px'}},
          {key: 'appName', label: '연결게임', thStyle: {width: '180px', textAlign: 'center'}, class: 'text-center'},
          {key: 'title', label: '톡채널 이름', thStyle: {width: '200px'}, class: 'text-center'},
          {key: 'modTime', label: '등록/수정일', thStyle: {width: '200px'}, class: 'text-center'},
          {key: 'modUserId', label: '등록/수정자', thStyle: {width: '200px'}, class: 'text-center'},
          // {key: 'genre', label: '장르', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '100px'} },
          // {key: 'aosAppStartTime', label: 'AOS 출시일', class: TABLE_CLASS_WITH_ELLIPSIS},
          // {key: 'iosAppStartTime', label: 'iOS 출시일', class: TABLE_CLASS_WITH_ELLIPSIS},
          // {key: 'modStatusTime', label: '등록/수정일', class: TABLE_CLASS_WITH_ELLIPSIS},
          // {key: 'edit', label: '게임 관리', class: TABLE_CLASS_WITH_ELLIPSIS}
        ],
        pgmAdList: [],
        apps: []
      }
    },
    computed: {
      filteredList() {
        return this.pgmAdList.filter((elem) => {
          return elem.title.includes(this.search)
        })
      }
    },
    mounted () {
      playGameService.getPlusFriends()
        .then((res) => {
          this.pgmAdList = res.data
        })
        .catch($showModalWithErrorMsg.bind(this))

      GameCenterService.getList()
        .then((res) => {
          this.apps = res.data.apps;
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    methods: {
      // 스낵게임이면 괄호를 추가한다.
      getAppName (pgmAd) {
        const found = this.apps.find((item) => {
          return item.appType === 'snackgame' && item.appMasterId === pgmAd.appMasterId
        })
        if (found === undefined) {
          return pgmAd.appName
        } else {
          return pgmAd.appName + '(스낵게임)'
        }
      },
      getFormattedDate(timestampInMilliseconds) {
        return moment(timestampInMilliseconds).format('YYYY-MM-DD HH:mm:ss')
      },
      ...mapMutations('ui', [SHOW_MODAL])
    }

  }
</script>
<style scoped>
</style>
